import { ApiClientError } from '../../../shared/api/client.js';

/**
 * 409 — "hozir bo'lmadi, yana urin".
 *
 * Backend optimistik blokirovka konfliktida (`placement.version`) va bloklangan
 * katakda aynan 409 qaytaradi. Bu UMUMIY xato emas: ish bajarilmagan, lekin
 * hech narsa buzilmagan ham — shu sababli ekranda "xatolik yuz berdi" emas,
 * qayta urinish taklifi turishi kerak.
 */
export const isRetryableConflict = (error: unknown): boolean =>
  error instanceof ApiClientError && error.status === 409;

/** Serverning xabari odam uchun yozilgan — u bor bo'lsa o'zimizniki yashirmaydi. */
export const stockErrorText = (error: unknown, fallback: string): string =>
  error instanceof ApiClientError ? error.message : fallback;
